module.exports = __webpack_public_path__ + "img/person-reg.fe032b2e.svg";